import type { EditableBillWire } from './editableBillMapping.ts';
import type { ValidationResult } from './validationIssues.ts';

export interface DocumentSavePayload {
    document_id: string;
    business_id: string;
    editable_bill: EditableBillWire;
}

export interface SaveFailureToast {
    title: string;
    description: string;
    type: 'error';
}

export function validationResultFromError(error: unknown): ValidationResult | null {
    const detail = (error as { detail?: { validation_result?: ValidationResult } } | undefined)?.detail;
    return detail?.validation_result ?? null;
}

export function saveFailureToast(error: unknown): SaveFailureToast {
    if (validationResultFromError(error)) {
        return {
            title: 'Document niet opgeslagen',
            description: 'Vul de gemarkeerde velden aan om het document op te slaan.',
            type: 'error',
        };
    }

    console.error('Error saving document:', error);
    return {
        title: 'Fout opgetreden',
        description: 'Er is een fout opgetreden bij het opslaan van het document. Probeer het later opnieuw.',
        type: 'error',
    };
}
